import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for this feature.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Load the functionalizations calculated from the labs currently assigned to
     * this Lab Service. Resolves the scenario context and lab record ids from the
     * collection in the effect.
     */
    loadForCurrentEntity: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<ents.extra.space.Functionalization[]>(),
      reducers: {
        request: () => ({
          ...State.INITIAL,
          isLoading: true,
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          error: undefined,
          functionalizations: response,
          isLoading: false,
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          error,
          isLoading: false,
        }),
        cancellation: () => State.INITIAL,
      },
    }),
    /**
     * Transport-only request that fetches the calculated functionalizations for
     * the supplied scenario context and lab records.
     */
    load: store.actions.request({
      input: store.actions.Data.asIs<{
        context: ents.core.admin.Context.ForScenario
        spaceRecordIds: readonly ents.core.dms.data.Record.Id[]
      }>(),
      output: store.actions.Data.asIs<ents.extra.space.Functionalization[]>(),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
